import { combineReducers } from "@reduxjs/toolkit";
import applications from './applications/slice'
import events from './events/slice'
import loading from './loading/slice'


const participantReducer = combineReducers({ applications, events, loading })


export default participantReducer